<template>
  <div class="research-origin-data" v-loading="tableLoading">
    <origin-data
      ref="originDataTableRef"
      :hits="caseList"
      :caseTotal="caseTotal"
      :instrumentType="courseDetail._source.instrumentType"
      :courseFilterArr="courseFilterArr"
      :filter-arr="conditionFilterArr"
      :tableColumns="sortFields(researchModel.fields, curSortIds)"
      :total="pageInfo.total"
      :page.sync="pageInfo.page"
      :size.sync="pageInfo.size"
      :courseId="courseDetail ? courseDetail._id : ''"
      :courseCondition="courseDetail._source.condition"
      :courseSortInfo="courseDetail._source.sortInfo"
      :researchSortInfo="sortInfo"
      :tool-actions="toolActions"
      :showFilter="false"
      tapRowAction="article"
      :filterUnitGroupName="researchModel.relationFilterName"
      @changeFilter="changeTableFilter"
      @changePageInfo="getCaseList()"
      @delColumn="delColumnHandle"
      @delSortInfo="sortInfo => sortHandle(sortInfo.action, { headerItem: sortInfo.fieldInfo })"
      @asc="params => sortHandle('asc', params)"
      @desc="params => sortHandle('desc', params)"
      @customSort="({ headerItem }) => customSortModalShowHandle(headerItem)"
    />

    <customSortModal
      v-if="customSortModal.show"
      :show.sync="customSortModal.show"
      :courseId="courseDetail._id"
      :groupName="researchModel.relationFilterName"
      :defaultFieldDetail="customSortModal.fieldDetail"
      :fields="sortFields(researchModel.fields, curSortIds)"
      :defaultSortInfoCustom="sortInfoCustom"
      @change="changeSortInfoCustom"
    />
  </div>
</template>

<script>
import originData from '@/components/originData';
import customSortModal from '@/components/customSortModal.vue';
import { getSortInfo, fetchFieldsQuery, sortFields } from '@/lib/utils';

import { services } from '@/service';
import EventBus from '@/lib/eventBus';

export default {
  components: { originData, customSortModal },
  data() {
    return {
      pageInfo: {
        total: 0,
        page: 1,
        size: 20
      },
      caseList: [],
      caseTotal: 0,
      tableLoading: false,
      conditionFilterArr: [],
      sortInfo: null,
      sortInfoCustom: [],
      customSortModal: {
        show: false,
        fieldDetail: null
      }
    };
  },
  props: {
    courseDetail: {
      type: Object,
      required: true
    },
    chartIndexId: {
      type: Number,
      required: true
    },
    researchModel: {
      type: Object,
      required: true
    },
    handleDisabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    courseFilterArr() {
      return JSON.parse(this.courseDetail._source.conditionTemp || '[]');
    },
    mergeDataSource() {
      return JSON.stringify({ query: [...this.courseFilterArr, ...this.conditionFilterArr] });
    },
    toolActions() {
      const actions = {
        sort: {
          actions: [
            { action: 'asc', title: '升序' },
            { action: 'desc', title: '降序' }
          ]
        },
        customSort: {
          actions: [{ action: 'customSort', title: '自定义排序' }]
        },
        filter: { actions: [{ action: 'filter', title: '筛选器' }] },
        delField: {
          iconName: '',
          actions: [{ action: 'delColumn', title: '移除' }]
        }
      };
      if (this.handleDisabled) {
        delete actions.field;
        delete actions.delField;
      }
      return actions;
    },
    curSortIds() {
      return ((this.researchModel.hideAndSort || {})[this.relationFilterVal] || {}).sortIds || [];
    }
  },
  beforeDestroy() {
    EventBus.$off('getCaseList', this.getCaseList);
    EventBus.$off('originDataAction', this.originDataAction);
    EventBus.$off('fetchQueryBody', this.fetchQueryBody);
  },
  created() {
    EventBus.$on('getCaseList', this.getCaseList);
    EventBus.$on('originDataAction', this.originDataAction);
    EventBus.$on('fetchQueryBody', this.fetchQueryBody);
  },
  mounted() {
    this.init(this.researchModel);
    this.$emit('initApis', {
      init: researchModel => this.init(researchModel)
    });
  },
  methods: {
    sortFields,
    init(item) {
      if (item.conditionTemp) {
        this.conditionFilterArr = JSON.parse(item.conditionTemp);
      }
      this.sortInfo = item.sortInfo;
      this.sortInfoCustom = item.sortInfoCustom || [];
    },
    fetchQueryBody(callback) {
      const mergeDataSource = JSON.parse(this.mergeDataSource);
      const sortInfo = getSortInfo([this.sortInfo || this.courseDetail._source.sortInfo], this.sortInfoCustom);
      const fields = this.researchModel.fields.map(fieldItem => fetchFieldsQuery(fieldItem));
      const queryBody = {
        ...sortInfo,
        ...mergeDataSource,
        fields,
        track_total_hits: true,
        courseware_id: this.$route.query.courseware_id
      };
      const relationFilterVal = this.researchModel.relationFilterVal;
      if (relationFilterVal && relationFilterVal !== 'case') {
        queryBody.parentId = relationFilterVal;
      }
      if (callback) {
        callback(queryBody);
      }
      return queryBody;
    },
    async getCaseList() {
      try {
        this.tableLoading = true;
        const { page, size } = this.pageInfo;

        const queryBody = this.fetchQueryBody();
        const result = await services.originCase.getCaseLabelList({
          ...queryBody,
          from: (page - 1) * size,
          size: size
        });
        const { hits, total } = result;
        this.caseList = hits;
        this.pageInfo.total = total || 0;
        // this.caseTotal = result.count;
      } catch (err) {
        this.$error(err);
      } finally {
        this.tableLoading = false;
      }
    },
    originDataAction({ func, params }) {
      if (func === 'delSortCustomHandle') {
        this.changeSortInfoCustom();
        return;
      }
      const elFunc = this.$refs.originDataTableRef[func];
      elFunc && elFunc(params);
    },
    changeTableFilter(filterArr) {
      this.conditionFilterArr = filterArr;
      this.pageInfo.page = 1;
      this.$emit('changeOriginData', {
        chartIndexId: this.chartIndexId,
        saveChart: false,
        detail: {
          ...this.researchModel,
          conditionTemp: JSON.stringify(filterArr)
        }
      });
    },
    sortHandle(sortAction, params) {
      const { headerItem } = params;
      const currentSortInfo = this.researchModel.sortInfo;
      let newSortInfo = { action: sortAction, fieldInfo: headerItem };
      if (
        currentSortInfo &&
        currentSortInfo.action === sortAction &&
        currentSortInfo.fieldInfo.columnKey === headerItem.columnKey
      ) {
        newSortInfo = null;
      }
      this.sortInfo = newSortInfo;
      this.pageInfo.page = 1;
      this.$emit('changeOriginData', {
        chartIndexId: this.chartIndexId,
        saveChart: false,
        detail: {
          ...this.researchModel,
          sortInfo: newSortInfo
        }
      });
    },
    customSortModalShowHandle(fieldDetail) {
      this.customSortModal = {
        show: true,
        fieldDetail
      };
    },
    changeSortInfoCustom(sortInfoCustom = []) {
      this.sortInfoCustom = sortInfoCustom;
      this.pageInfo.page = 1;
      this.$emit('changeOriginData', {
        chartIndexId: this.chartIndexId,
        saveChart: false,
        detail: {
          ...this.researchModel,
          sortInfoCustom: this.sortInfoCustom
        }
      });
    },
    async delColumnHandle({ headerItem }) {
      await this.$confirm(`是否移除标签【${headerItem.title}】？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      });
      const index = this.researchModel.fields.findIndex(item => item.columnKey === headerItem.columnKey);
      if (index === -1) {
        return;
      }
      const fields = [...this.researchModel.fields];
      fields.splice(index, 1);
      this.$emit('changeChartDetail', {
        refreshData: true,
        chartIndexId: this.chartIndexId,
        detail: {
          ...this.researchModel,
          fields
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.research-origin-data {
}
</style>
